import {JsonProperty} from '../shared/decorators/json-property';

export class IbRequestModel {
  @JsonProperty('ib_request_id')
  id: number;
  @JsonProperty('parent_id')
  parentId: number;
  @JsonProperty('user_id')
  userId: number;
  status: number;
  refer: string;
  data: any;
  email: string;
  country: string;
  @JsonProperty('first_name')
  firstName: string;
  @JsonProperty('middle_name')
  middleName: string;
  @JsonProperty('last_name')
  lastName: string;
  @JsonProperty('create_time')
  createTime: number;
  constructor() {
    this.id = undefined;
    this.userId = undefined;
    this.parentId = undefined;
    this.refer = undefined;
    this.data = {};
    this.lastName = undefined;
    this.middleName = undefined;
    this.firstName = undefined;
    this.email = undefined;
    this.createTime = undefined;
    this.country = undefined;
  }
  getUsername(): string {
    return ((this.firstName) ? this.firstName : '') +
      ' ' + ((this.middleName) ? this.middleName : '') +
      ' ' + ((this.lastName) ? this.lastName : '');
  }
}
